import { supabase } from "../../../supabaseClient";

export async function getAuthToken() {
    const { data: sessionData } = await supabase.auth.getSession();
    return sessionData.session?.access_token || "";
}

export async function getCurrentUserId() {
    const { data: sessionData } = await supabase.auth.getSession();
    return sessionData.session?.user?.id || "default";
}